import request from '../../utils/requests'

/**
 * Tag: Class
 */

const baseUrl ="/api/CourseClass";



/**
 * 获取班级详情
 * @param {*} body
 * {
 *    ClassId Desc:班级ID Required:false
 *    BranchId Desc:校区ID(大于0时会加入查询，=0时忽略) Required:false
 *    OrgId Desc:机构ID(后台使用，不用传) Required:false
 * }
 */
async function _getClassDetail(body) {
  return request(baseUrl+'/getClassDetail',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取班级详情-学员
 * @param {*} body
 * {
 *    ClassName Desc:班级名称 Required:false
 *    ClassId Desc:班级ID Required:false
 *    CourseId Desc:课程ID Required:false
 *    BranchId Desc:校区IDList Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    StartTime Desc:开始时间 Required:false
 *    EndTime Desc:结束时间 Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    OrgSiteList Desc:场地 Required:false
 *    CreateUserId Desc:经办人（签到人） Required:false
 *    AttendDateStart Desc:签到日期-开始 Required:false
 *    AttendDateEnd Desc:签到日期-结束 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getClassDetailStudent(body) {
  return request(baseUrl+'/getClassDetailStudent',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取班级有效课卡的学员
 * @param {*} body
 * {
 *    ClassName Desc:班级名称 Required:false
 *    ClassId Desc:班级ID Required:false
 *    CourseId Desc:课程ID Required:false
 *    BranchId Desc:校区IDList Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    StartTime Desc:开始时间 Required:false
 *    EndTime Desc:结束时间 Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    OrgSiteList Desc:场地 Required:false
 *    CreateUserId Desc:经办人（签到人） Required:false
 *    AttendDateStart Desc:签到日期-开始 Required:false
 *    AttendDateEnd Desc:签到日期-结束 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getClassValidStudent(body) {
  return request(baseUrl+'/getClassValidStudent',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取班级详情-课时列表
 * @param {*} body
 * {
 *    ClassName Desc:班级名称 Required:false
 *    ClassId Desc:班级ID Required:false
 *    CourseId Desc:课程ID Required:false
 *    BranchId Desc:校区IDList Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    StartTime Desc:开始时间 Required:false
 *    EndTime Desc:结束时间 Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    OrgSiteList Desc:场地 Required:false
 *    CreateUserId Desc:经办人（签到人） Required:false
 *    AttendDateStart Desc:签到日期-开始 Required:false
 *    AttendDateEnd Desc:签到日期-结束 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getClassDetailSchedule(body) {
  return request(baseUrl+'/getClassDetailSchedule',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取班级详情-上课记录
 * @param {*} body
 * {
 *    ClassName Desc:班级名称 Required:false
 *    ClassId Desc:班级ID Required:false
 *    CourseId Desc:课程ID Required:false
 *    BranchId Desc:校区IDList Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    StartTime Desc:开始时间 Required:false
 *    EndTime Desc:结束时间 Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    OrgSiteList Desc:场地 Required:false
 *    CreateUserId Desc:经办人（签到人） Required:false
 *    AttendDateStart Desc:签到日期-开始 Required:false
 *    AttendDateEnd Desc:签到日期-结束 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getClassDetailRecord(body) {
  return request(baseUrl+'/getClassDetailRecord',{
    method: 'POST',
    body: body,
  });

}
/**
 *  未排课打卡列表
 * @param {*} body 
 */
async function _GetNoClassScheduleAttend(body) {
  return request(baseUrl+'/GetNoClassScheduleAttend',{
    method: 'POST',
    body: body,
  });

}

/**
 * 获取班级详情-上课记录导出
 * @param {*} body
 * {
 *    ClassName Desc:班级名称 Required:false
 *    ClassId Desc:班级ID Required:false
 *    CourseId Desc:课程ID Required:false
 *    BranchId Desc:校区IDList Required:false
 *    NameOrPhone Desc:姓名或手机号 Required:false
 *    StartTime Desc:开始时间 Required:false
 *    EndTime Desc:结束时间 Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    OrgSiteList Desc:场地 Required:false
 *    CreateUserId Desc:经办人（签到人） Required:false
 *    AttendDateStart Desc:签到日期-开始 Required:false
 *    AttendDateEnd Desc:签到日期-结束 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getClassDetailRecordExp(body) {
  return request(baseUrl+'/getClassDetailRecordExp',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取某一课时学员，用于记上课展示
 * @param {*} param
 * {
 *    scheduleId Desc: Required:true
 * }
 */
async function _getClassDetailScheduleStudent(param) {
  return request(baseUrl+'/getClassDetailScheduleStudent',{
    method: 'GET',
    params: param,
  });

}



/**
 * 获取某一课时老师，用于记上课展示
 * @param {*} param
 * {
 *    scheduleId Desc: Required:true
 * }
 */
async function _getClassDetailScheduleTeacher(param) {
  return request(baseUrl+'/getClassDetailScheduleTeacher',{
    method: 'GET',
    params: param,
  });

}



/**
 * GetModel
 * @param {*} body
 * {
 *    ClassId Desc:班级ID Required:false
 *    BranchId Desc:校区ID(大于0时会加入查询，=0时忽略) Required:false
 *    OrgId Desc:机构ID(后台使用，不用传) Required:false
 * }
 */
async function _getModel(body) {
  return request(baseUrl+'/getModel',{
    method: 'POST',
    body: body,
  });

}



/**
 * 班级分页
 * @param {*} body
 * {
 *    BranchId Desc:校区ID，大于0时加入查询 Required:false
 *    ClassName Desc:班级名称 Required:false
 *    CourseId Desc:课程IDList Required:false
 *    UniqueCode Desc:班级编号 Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    OrgSiteList Desc:上课场地 Required:false
 *    EnrolmentStatus Desc:招生状态 1.开放招生 2.停止招生 全部：小于等于0 Required:false
 *    ClassType Desc:班级类型 1:团课 2:预约课 全部：小于等于0 Required:false
 *    Day Desc:上课时间：周几，大于0时加入查询 Required:false
 *    StartTime Desc:上课时间：开始(格式 1503),0~2359,大于-1时加入查询 Required:false
 *    EndTime Desc:上课时间：结束(格式 1503),0~2359,大于-1时加入查询 Required:false
 *    ExistsSchedule Desc:是否存在课时（今天及以后是否有排课）,1:已排课，0：未排课，null/不传：全部 Required:false
 *    CourseClassTagId Desc:班级标签 Required:false
 *    TagSelectType Desc:标签筛选方式（默认并集） Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _paging(body) {
  return request(baseUrl+'/paging',{
    method: 'POST',
    body: body,
  });

}



/**
 * 分班分页查询
 * @param {*} body
 * {
 *    StudentId Desc:学员ID：必填 Required:true
 *    CourseId Desc:课程ID：必填 Required:true
 *    BranchId Desc:校区ID：必填 Required:true
 *    IsCurrencyCard Desc:是否为通卡,默认false Required:false
 *    ClassName Desc:班级名称 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _pagingForDivideIntoClass(body) {
  return request(baseUrl+'/pagingForDivideIntoClass',{
    method: 'POST',
    body: body,
  });

}



/**
 * 班级新增(团班/集体班)
 * @param {*} body
 * {
 *    ClassId Desc:班级ID Required:false
 *    CourseClassId Desc:班级ID Required:false
 *    ClassName Desc:班级名称 Required:true
 *    CourseId Desc:所属课程 Required:false
 *    UniqueCode Desc:班级编号 Required:false
 *    OrgSiteId Desc:上课场地 Required:false
 *    MaxStuCount Desc:最大人数（学生数量） Required:false
 *    DefDeductCount Desc:班级默认扣课次数 Required:false
 *    DefLessonPlan Desc:默认教案 Required:false
 *    BookCancelSetting Desc:开启预约模式后可设置，开课前多长时间（分钟）不可取消预约 Required:false
 *    EnrolmentStatus Desc:招生状态  1.开放招生 2.停止招生 Required:false
 *    BranchId Desc:校区ID Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    ClassDayTimeList Desc:上课时间 Required:false
 *    CourseClassTagList Desc:班级标签List，存ID Required:false
 * }
 */
async function _addForGourp(body) {
  return request(baseUrl+'/addForGourp',{
    method: 'POST',
    body: body,
  });

}



/**
 * 班级更新(团班/集体班)
 * @param {*} body
 * {
 *    ClassId Desc:班级ID Required:false
 *    CourseClassId Desc:班级ID Required:false
 *    ClassName Desc:班级名称 Required:true
 *    CourseId Desc:所属课程 Required:false
 *    UniqueCode Desc:班级编号 Required:false
 *    OrgSiteId Desc:上课场地 Required:false
 *    MaxStuCount Desc:最大人数（学生数量） Required:false
 *    DefDeductCount Desc:班级默认扣课次数 Required:false
 *    DefLessonPlan Desc:默认教案 Required:false
 *    BookCancelSetting Desc:开启预约模式后可设置，开课前多长时间（分钟）不可取消预约 Required:false
 *    EnrolmentStatus Desc:招生状态  1.开放招生 2.停止招生 Required:false
 *    BranchId Desc:校区ID Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    ClassDayTimeList Desc:上课时间 Required:false
 *    CourseClassTagList Desc:班级标签List，存ID Required:false
 * }
 */
async function _updateForGourp(body) {
  return request(baseUrl+'/updateForGourp',{
    method: 'POST',
    body: body,
  });

}



/**
 * 班级新增(预约班)
 * @param {*} body
 * {
 *    ClassId Desc:班级ID Required:false
 *    CourseClassId Desc:班级ID Required:false
 *    ClassName Desc:班级名称 Required:true
 *    CourseId Desc:所属课程 Required:false
 *    UniqueCode Desc:班级编号 Required:false
 *    OrgSiteId Desc:上课场地 Required:false
 *    MaxStuCount Desc:最大人数（学生数量） Required:false
 *    DefDeductCount Desc:班级默认扣课次数 Required:false
 *    DefLessonPlan Desc:默认教案 Required:false
 *    BookCancelSetting Desc:开启预约模式后可设置，开课前多长时间（分钟）不可取消预约 Required:false
 *    EnrolmentStatus Desc:招生状态  1.开放招生 2.停止招生 Required:false
 *    BranchId Desc:校区ID Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    ClassDayTimeList Desc:上课时间 Required:false
 *    CourseClassTagList Desc:班级标签List，存ID Required:false
 * }
 */
async function _addForBook(body) {
  return request(baseUrl+'/addForBook',{
    method: 'POST',
    body: body,
  });

}



/**
 * 班级更新(预约班)
 * @param {*} body
 * {
 *    ClassId Desc:班级ID Required:false
 *    CourseClassId Desc:班级ID Required:false
 *    ClassName Desc:班级名称 Required:true
 *    CourseId Desc:所属课程 Required:false
 *    UniqueCode Desc:班级编号 Required:false
 *    OrgSiteId Desc:上课场地 Required:false
 *    MaxStuCount Desc:最大人数（学生数量） Required:false
 *    DefDeductCount Desc:班级默认扣课次数 Required:false
 *    DefLessonPlan Desc:默认教案 Required:false
 *    BookCancelSetting Desc:开启预约模式后可设置，开课前多长时间（分钟）不可取消预约 Required:false
 *    EnrolmentStatus Desc:招生状态  1.开放招生 2.停止招生 Required:false
 *    BranchId Desc:校区ID Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    ClassDayTimeList Desc:上课时间 Required:false
 *    CourseClassTagList Desc:班级标签List，存ID Required:false
 * }
 */
async function _updateForBook(body) {
  return request(baseUrl+'/updateForBook',{
    method: 'POST',
    body: body,
  });

}



/**
 * 单条删除
 * @param {*} param
 * {
 *    expCourseId Desc:体验课ID Required:true
 * }
 */
async function _delete(param) {
  return request(baseUrl+'/delete',{
    method: 'GET',
    params: param,
  });

}



/**
 * 批量删除
 * @param {*} body
 * {
 *    IdList Desc:IDList Required:false
 *    BranchId Desc:校区ID,校区时填当前校区,机构时填《=0即可 Required:false
 *    CourseIdList Desc:课程Id列表（获取课程班级列表时传，其他不需要传） Required:false
 *    EnrolmentStatus Desc:招生状态枚举 EEnrolmentStatus -1全部 1开放 2停止 Required:false
 * }
 */
async function _batchDelete(body) {
  return request(baseUrl+'/batchDelete',{
    method: 'POST',
    body: body,
  });

}



/**
 * 开放招生
 * @param {*} body
 * {
 *    IdList Desc:IDList Required:false
 *    BranchId Desc:校区ID,校区时填当前校区,机构时填《=0即可 Required:false
 *    CourseIdList Desc:课程Id列表（获取课程班级列表时传，其他不需要传） Required:false
 *    EnrolmentStatus Desc:招生状态枚举 EEnrolmentStatus -1全部 1开放 2停止 Required:false
 * }
 */
async function _open(body) {
  return request(baseUrl+'/open',{
    method: 'POST',
    body: body,
  });

}



/**
 * 停止招生
 * @param {*} body
 * {
 *    IdList Desc:IDList Required:false
 *    BranchId Desc:校区ID,校区时填当前校区,机构时填《=0即可 Required:false
 *    CourseIdList Desc:课程Id列表（获取课程班级列表时传，其他不需要传） Required:false
 *    EnrolmentStatus Desc:招生状态枚举 EEnrolmentStatus -1全部 1开放 2停止 Required:false
 * }
 */
async function _stop(body) {
  return request(baseUrl+'/stop',{
    method: 'POST',
    body: body,
  });

}



/**
 * 报名续费获取班级列表
 * @param {*} param
 * {
 *    req.branchId Desc:校区ID，大于0时加入查询 Required:false
 *    req.orgId Desc:机构ID 当前登陆自带 Required:false
 *    req.className Desc:班级名称 Required:false
 *    req.courseId Desc:课程ID，大于0时加入查询 Required:false
 *    req.tORAName Desc:老师或者助教名称 Required:false
 *    req.day Desc:上课时间：周几，大于0时加入查询 Required:false
 *    req.startTime Desc:上课时间：开始(格式 1503),0~2359,大于-1时加入查询 Required:false
 *    req.endTime Desc:上课时间：结束(格式 1503),0~2359,大于-1时加入查询 Required:false
 * }
 */
async function _classForFeeList(param) {
  return request(baseUrl+'/classForFeeList',{
    method: 'GET',
    params: param,
  });

}



/**
 * 分班（指定学生，多个班级）
 * @param {*} body
 * {
 *    StudentId Desc:学员ID：必填 Required:true
 *    StudentList Desc:学员IDList(未分班学员使用) Required:false
 *    BranchId Desc:校区ID：必填 Required:true
 *    IsCurrencyCard Desc:是否为通卡 Required:false
 *    CourseId Desc:课程ID(通卡ID)：必填 Required:true
 *    DivideInfo Desc:分班明细 Required:false
 *    CourseName Desc:课程名 Required:false
 * }
 */
async function _divideIntoClass(body) {
  return request(baseUrl+'/divideIntoClass',{
    method: 'POST',
    body: body,
  });

}



/**
 * 分班（未分班学员分班）
 * @param {*} body
 * {
 *    StudentId Desc:学员ID：必填 Required:true
 *    StudentList Desc:学员IDList(未分班学员使用) Required:false
 *    BranchId Desc:校区ID：必填 Required:true
 *    IsCurrencyCard Desc:是否为通卡 Required:false
 *    CourseId Desc:课程ID(通卡ID)：必填 Required:true
 *    DivideInfo Desc:分班明细 Required:false
 *    CourseName Desc:课程名 Required:false
 * }
 */
async function _divideIntoClassForStudentList(body) {
  return request(baseUrl+'/divideIntoClassForStudentList',{
    method: 'POST',
    body: body,
  });

}



/**
 * 分班（指定班级，多个学生）
 * @param {*} body
 * {
 *    StudentIdList Desc:学员ID：必填 Required:true
 *    BranchId Desc:校区ID：必填 Required:true
 *    CourseId Desc:课程ID：必填 Required:true
 *    CourseClassId Desc:班级ID：必填 Required:true
 *    CouseClassName Desc:班级名 Required:false
 *    CourseName Desc:课程名 Required:false
 * }
 */
async function _divideIntoClassForClass(body) {
  return request(baseUrl+'/divideIntoClassForClass',{
    method: 'POST',
    body: body,
  });

}



/**
 * 查询结班列表
 * @param {*} body
 * {
 *    StudentId Desc:学生ID Required:false
 *    CourseId Desc:课程ID Required:false
 *    BranchId Desc:校区ID(大于0时会加入查询，=0时忽略) Required:false
 *    OrgId Desc:机构ID(后台使用，不用传) Required:false
 * }
 */
async function _getClassForCloseList(body) {
  return request(baseUrl+'/getClassForCloseList',{
    method: 'POST',
    body: body,
  });

}



/**
 * 全部结班操作
 * @param {*} body
 * {
 *    BranchId Desc:校区ID(大于0时会加入查询，=0时忽略) Required:false
 *    OrgId Desc:机构ID(后台使用，不用传) Required:false
 *    StudentId Desc:学生Id 学员集合结班 Required:false
 *    CourseId Desc:课程ID Required:false
 *    CourseName Desc:课程名称 Required:false
 *    ClassId Desc:班级Id Required:false
 *    ClassIds Desc:班级Id集合 Required:false
 *    RemarkType Desc:操作描述类型 Required:false
 * }
 */
async function _closeClassForALLStudent(body) {
  return request(baseUrl+'/closeClassForALLStudent',{
    method: 'POST',
    body: body,
  });

}



/**
 * 单个学员结班
 * @param {*} body
 * {
 *    BranchId Desc:校区ID(大于0时会加入查询，=0时忽略) Required:false
 *    OrgId Desc:机构ID(后台使用，不用传) Required:false
 *    StudentId Desc:学生Id 学员集合结班 Required:false
 *    CourseId Desc:课程ID Required:false
 *    CourseName Desc:课程名称 Required:false
 *    ClassId Desc:班级Id Required:false
 *    ClassIds Desc:班级Id集合 Required:false
 *    RemarkType Desc:操作描述类型 Required:false
 * }
 */
async function _closeClassForOneStudent(body) {
  return request(baseUrl+'/closeClassForOneStudent',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取根据课程id获取班级列表
 * @param {*} param
 * {
 *    branchid Desc:校区 Required:true
 *    courseid Desc:课程 Required:true
 * }
 */
async function _getClassByCourseid(param) {
  return request(baseUrl+'/getClassByCourseid',{
    method: 'GET',
    params: param,
  });

}



/**
 * 学员档案单个学员结班
 * @param {*} body
 * {
 *    BranchId Desc:校区ID(大于0时会加入查询，=0时忽略) Required:false
 *    OrgId Desc:机构ID(后台使用，不用传) Required:false
 *    StudentId Desc:学生Id 学员集合结班 Required:false
 *    CourseId Desc:课程ID Required:false
 *    CourseName Desc:课程名称 Required:false
 *    ClassId Desc:班级Id Required:false
 *    ClassIds Desc:班级Id集合 Required:false
 *    RemarkType Desc:操作描述类型 Required:false
 * }
 */
async function _closeManyClassForOneStudent(body) {
  return request(baseUrl+'/closeManyClassForOneStudent',{
    method: 'POST',
    body: body,
  });

}

async function _batchArrangeSchedule(body) {
  return request(baseUrl+'/BatchArrangeSchedule',{
    method: 'POST',
    body: body,
  });

}

export default{
  _getClassDetail,
  _getClassDetailStudent,
  _getClassValidStudent,
  _getClassDetailSchedule,
  _getClassDetailRecord,
  _GetNoClassScheduleAttend,
  _getClassDetailRecordExp,
  _getClassDetailScheduleStudent,
  _getClassDetailScheduleTeacher,
  _getModel,
  _paging,
  _pagingForDivideIntoClass,
  _addForGourp,
  _updateForGourp,
  _addForBook,
  _updateForBook,
  _delete,
  _batchDelete,
  _open,
  _stop,
  _classForFeeList,
  _divideIntoClass,
  _divideIntoClassForStudentList,
  _divideIntoClassForClass,
  _getClassForCloseList,
  _closeClassForALLStudent,
  _closeClassForOneStudent,
  _getClassByCourseid,
  _closeManyClassForOneStudent,
  _batchArrangeSchedule
}




// WEBPACK FOOTER //
// ./src/services/courseClass.js